import { formatViewDate } from 'utils/date';
import { findPathPages } from 'utils/pages';

import { promotionsPath } from 'components/config/cloud';
import { PAGE_PATH } from 'components/config/pages';
import { CATEGORIES } from 'components/config/promotions';
import { PROVIDERS } from 'config/organization';

export const getFolderPath = (folderPath) => `${promotionsPath}${folderPath}`;

export const getImagePath = (folderPath, imageName) =>
  `${getFolderPath(folderPath)}${imageName}`;

export const getPhaseName = (name) => name.replace(/\[[^\]]*\]/g, '').trim();

export const getTags = (promotion) => {
  if (promotion?.promotions?.length) {
    const all = promotion.promotions.flatMap(({ tags }) => tags);

    return all.reduce(
      (acc, tag) =>
        !acc.find(({ key }) => key === tag.key) ? [...acc, tag] : acc,
      [],
    );
  }

  return promotion?.tags;
};

export const getDateFilters = (category, date) => {
  const formatted = `${date.toISOString().split('.')[0]}+00:00`;

  switch (category) {
    case CATEGORIES.comingSoon.value:
      return {
        'filters[startDate][$gt]': formatted,
      };
    case CATEGORIES.running.value:
      return {
        'filters[startDate][$lte]': formatted,
        'filters[endDate][$gt]': formatted,
      };
    case CATEGORIES.ended.value:
      return {
        'filters[endDate][$lte]': formatted,
      };
  }
};

export const isRunning = ({ startDate, endDate } = {}) =>
  new Date(startDate).getTime() <= Date.now() &&
  new Date(endDate).getTime() > Date.now();

export const sortByMain = (promotions = []) => {
  const getNumeric = (isMain) => (isMain ? 1 : 0);

  return [...promotions].sort(
    (a, b) => getNumeric(b.isMain) - getNumeric(a.isMain),
  );
};

export const getSliderData = (promotions = []) =>
  promotions.map(
    ({
      documentId,
      name,
      folderPath,
      startDate,
      endDate,
      description,
      promotions,
      tags,
    }) => ({
      name,
      gameCode: name,
      description,
      releaseDate: `${formatViewDate(new Date(startDate))} - ${formatViewDate(
        new Date(endDate),
      )}`,
      sliderSmall: getImagePath(folderPath, 'slider_small.webm'),
      sliderLarge: getImagePath(folderPath, 'slider_large.webm'),
      icon: getImagePath(folderPath, 'slider_thumb.jpg'),
      promoTags: getTags({ promotions, tags }),
      link: findPathPages(PAGE_PATH.PROMOTIONS_ITEM)
        .replace(':provider', PROVIDERS.evoplay)
        .replace(':category', CATEGORIES.comingSoon.value)
        .replace(':id', documentId),
    }),
  );

export const marketsToString = (markets = []) =>
  markets.map(({ item }) => item).join(', ');

export const getPackStructure = (materials) => {
  const result = {};
  if (!Array.isArray(materials)) {
    Object.keys(materials).map((pack) => {
      Array.isArray(materials[pack]) &&
        materials[pack].map((item) => {
          result[item] = result[item] ? result[item].concat(pack) : [pack];
        });
    });
  }
  return result;
};
